import BorderedFilterItemCard from "app/pages/sales-intelligence/common-components/filters-panel/components/FilterItemCard/BorderedFilterItemCard";
import type { CrmScopeOption } from "app/pages/sales-intelligence/domain/leads/types/filter-values";
import { crmScopeOptionMap } from "app/pages/sales-intelligence/domain/leads/types/filter-values";
import { RadioGroupFilter } from "app/pages/sales-intelligence/modules/advanced-search-filtering/components/filters/RadioGroupFilter/RadioGroupFilter";
import { RadioGroupFilterModel } from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/RadioGroupFilterModel";

import { leadsFilterCategoryMap } from "../../types/leadsFilterCategory";
import type { LeadsSearchFilterInstance } from "../../types/leadsSearchFilterInstance";
import leadsSearchFiltersI18nKeys from "../../utils/i18n";

const FILTER_KEY = "crmScope";

const createCrmScopeFilter = (): LeadsSearchFilterInstance => ({
    key: FILTER_KEY,
    trackingName: "CRM Scope",
    title: { key: leadsSearchFiltersI18nKeys.filter(FILTER_KEY) },
    hideTitleInPanel: true,
    apiCategory: "leadsFilters",
    category: leadsFilterCategoryMap.crm,
    visibility: "always-visible",
    filterCardLayout: "full-width",
    filter: new RadioGroupFilterModel<CrmScopeOption>({
        options: Object.values(crmScopeOptionMap).map((key) => ({
            key,
            label: leadsSearchFiltersI18nKeys.crmScopeOptionLabel(key),
            tooltip: leadsSearchFiltersI18nKeys.crmScopeOptionTooltip(key),
        })),
        initialDtoValue: crmScopeOptionMap.both,
    }),
    filterResultView: RadioGroupFilter<CrmScopeOption>,
    filterCardView: BorderedFilterItemCard,
});

export default createCrmScopeFilter;
